import {createSelector} from 'reselect';

import {getAbacusTests, getSystem} from './store';
import {evaluateExperiment} from '../utils/abacusHelper';

// ha_pulse_pdp_heart_share_buttons
const getPdpShareHeartTest = createSelector(
    [getAbacusTests, getSystem],
    (abacusTests, system) => {
        const isDeviceSm = system && system.deviceSize === 'sm';
        const isHeartShareTestVar1 = evaluateExperiment({
            abacus: abacusTests,
            name: 'ha_pulse_pdp_heart_share_buttons',
            variant: 1,
            deferLogging: false
        });

        const isHeartShareTestVar2 = evaluateExperiment({
            abacus: abacusTests,
            name: 'ha_pulse_pdp_heart_share_buttons',
            variant: 2,
            deferLogging: true
        });

        const isHeartShareTestVar3 = evaluateExperiment({
            abacus: abacusTests,
            name: 'ha_pulse_pdp_heart_share_buttons',
            variant: 3,
            deferLogging: true
        });
        const shareButtonExpanded = isHeartShareTestVar3;
        const heartButtonExpanded =
            isHeartShareTestVar1 || isHeartShareTestVar2 || isHeartShareTestVar3;
        const heartButtonInJumpNav =
            isHeartShareTestVar1 || isHeartShareTestVar2 || (isHeartShareTestVar3 && isDeviceSm);
        const shareButtonInJumpNav = isHeartShareTestVar2;
        return {
            shareButtonExpanded,
            heartButtonExpanded,
            shareButtonInJumpNav,
            heartButtonInJumpNav
        };
    }
);

export {getPdpShareHeartTest};
